module.exports = __webpack_public_path__ + "static/media/support-icon.0c1d9bc4.svg";